import React, { useContext } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import { TextViewer, TextInput, DatePickerBox } from '../form';
import { useForm } from '../../hooks';
import { SnackbarContext } from '../../contexts';
import Handler from '../../Handler';

// ITS-200. 방법론 공개논평 개설 모달.
export const ModalOpenMethodologyConsultation = (props) => {
  const { data, onClose, requestAction } = props;
  const { updateSnackbar } = useContext(SnackbarContext);

  const [formData, formMeta, formChange] = useForm(
    {
      title: '',
      titleEn: '',
      startDate: null,
      endDate: null,
    },
    {
      title: {
        key: 'title',
        label: '논평 제목',
        fullWidth: true,
        required: true,
      },
      titleEn: {
        key: 'titleEn',
        label: '논평 제목 (영문)',
        fullWidth: true,
        required: true,
      },
      startDate: {
        key: 'startDate',
        label: '시작일',
        fullWidth: true,
        required: true,
      },
      endDate: {
        key: 'endDate',
        label: '종료일',
        fullWidth: true,
        required: true,
      },
    },
  );

  if (!data) {
    return null;
  }

  const isDisabled = !formData.title || !formData.titleEn || !formData.startDate || !formData.endDate;

  const onConfirm = () => {
    if (new Date(formData.endDate) < new Date(formData.startDate)) {
      updateSnackbar({
        type: 'error',
        open: true,
        message: '논평 종료일은 시작일보다 빠를 수 없습니다.',
      });
      return;
    }
    requestAction({
      title: formData.title,
      titleEn: formData.titleEn,
      startDate: Handler.getYYYYMMDDByDate(formData.startDate),
      endDate: Handler.getYYYYMMDDByDate(formData.endDate),
    });
  };

  return (
    <article className='modal-action'>
      <header>
        <h3>공개논평 개설</h3>
        <IconButton style={{ marginRight: -10 }} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </header>
      <section className='section__container'>
        <header>
          <span>방법론 정보</span>
        </header>
        <ul className='form-list'>
          <TextViewer
            value={data.title}
            meta={{
              label: '방법론명',
              style: {},
              render: (value) => value,
            }}
          ></TextViewer>
          <TextViewer
            value={data.version}
            meta={{
              label: '버전',
              style: {},
              render: (value) => value,
            }}
          ></TextViewer>
        </ul>
      </section>
      <section className='section__container'>
        <header>
          <span>논평 정보</span>
        </header>
        <ul className='form-list'>
          <TextInput value={formData.title} onChange={formChange} meta={formMeta.title}></TextInput>
          <TextInput value={formData.titleEn} onChange={formChange} meta={formMeta.titleEn}></TextInput>
          <DatePickerBox value={formData.startDate} onChange={formChange} meta={formMeta.startDate}></DatePickerBox>
          <DatePickerBox value={formData.endDate} onChange={formChange} meta={formMeta.endDate}></DatePickerBox>
        </ul>
      </section>
      <section className='button__container'>
        <Button style={{ marginRight: 20 }} variant='outlined' onClick={onClose}>
          취소
        </Button>
        <Button disabled={isDisabled} size='large' variant='contained' onClick={onConfirm}>
          개설
        </Button>
      </section>
    </article>
  );
};
